import React, { useContext, useState } from "react";
import "../../Assets/css/influencer.css";
import { useNavigate, useParams } from "react-router-dom";
import { Grid, Typography, Box, useMediaQuery } from "@mui/material";

import BackVector from "../../Assets/Img/BackVector.svg";
import Mailbox from "../../Assets/Img/mailbox.svg";
import LocationSVG from "../../Assets/Img/LocationSVG.svg";
import Sampleimg from "../../Assets/Img/sampleimg.png";
import InstagramIcon from "../../Assets/Img/instagramICON.svg";
import YoutubeButton from "../../Assets/Img/youtubeButton.svg";
import fileicon from "../../Assets/Img/fileicon.png";
import axiosMain from "../../http/axiosMain";
import { GlobalContext } from "../../../utils/GlobalContext";

function ContractforCollaboration() {
  const navigate = useNavigate();
  const { requestId, setRequestId } = useContext(GlobalContext);
  const { id } = useParams();

  const [file, setFile] = useState(null);
  const [selectedFileName, setSelectedFileName] = useState("");
  const [previewUrl, setPreviewUrl] = useState(""); // 👈 Add preview state
  const isSmallScreen = useMediaQuery("(max-width:600px)");

  // Handle the file selection
  const handleFileSelect = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setSelectedFileName(selectedFile.name);

      // 👇 If image file, generate preview
      if (selectedFile.type.startsWith("image/")) {
        const url = URL.createObjectURL(selectedFile);
        setPreviewUrl(url);
      } else {
        setPreviewUrl("");
      }
    }
  };

  // Send the contract (file upload)
  const SendContract = async () => {
    if (!file) {
      alert("Please upload a file first");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("request_id", requestId);
      formData.append("file", file);

      const response = await axiosMain.post("/api/v1/send-contract", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      navigate(`/campaign-details/${id}`);
    } catch (error) {
      console.error(
        "Error:",
        error.response ? error.response.data : error.message
      );
    }
  };

  const backNavigate = () => {
    navigate(-1);
    localStorage.removeItem("activeCampaignTab");
  };

  return (
    <div
      className="content"
      style={{ padding: isSmallScreen ? "10px" : "20px" }}
    >
      <Box className="stat-item">
        <div
          className="upload-box"
          style={{
            border: "2px dashed rgba(103, 103, 103, 1)",
            padding: "20px",
            textAlign: "center",
            cursor: "pointer",
            position: "relative",
          }}
          onClick={() => document.getElementById("file-upload").click()}
        >
          <input
            id="file-upload"
            type="file"
            accept=".jpg,.png,.docx,.pdf"
            onChange={handleFileSelect}
            style={{ display: "none" }}
          />

          {selectedFileName ? (
            <div>
              {/* 👇 Show preview only for image files */}
              {previewUrl && (
                <img
                  src={previewUrl}
                  className="img-fluid"
                  alt="Preview img"
                  style={{
                    width: "100%",
                    maxHeight: "180px",
                    objectFit: "contain",
                    borderRadius: "8px",
                    border: "1px solid #ccc",
                  }}
                />
              )}
            </div>
          ) : (
            <>
              <img
                src={fileicon}
                alt="Upload Icon"
                className="upload-icon"
                style={{
                  width: "50px",
                  height: "50px",
                  marginBottom: "10px",
                }}
              />
              <p className="upload-text">Drag & Drop or Browse</p>
              <p className="upload-text">
                Supported files: docx, doc, pdf, jpg, png (Max size:{" "}
                <strong
                  style={{
                    color: "rgba(103, 103, 103, 1)",
                    fontWeight: "inherit",
                  }}
                >
                  5MB
                </strong>
                )
              </p>
            </>
          )}
        </div>

        {/* Submit Button */}
        <div className="d-flex justify-content-between mt-3">
          <p>{selectedFileName}</p>

          <div></div>
          <span className="GreenDarkBtn" onClick={SendContract}>
            Send Contract
          </span>
        </div>
      </Box>
    </div>
  );
}

export default ContractforCollaboration;
